import { Button } from '@headlessui/react';
import { FC } from 'react';
import { HeadingGroup } from '@/components/ui/heading-group';
import { HeadingGroupContainerLayout } from '@/layouts/heading-group-container-layout';
import { SectionContainerLayout } from '@/layouts/section-container-layout';
import { api } from '@/redux/api';
import { CreateCredentialsQueryArg } from '@/redux/api/endpoints/create-credentials';
import { CreateCredentialForm } from '../account/forms/create-credential-form';

export const CredentialsPage: FC = () => {
  const [createCredentials] = api.useCreateCredentialsMutation();
  const [alignAddressBooks] = api.useAlignAddressBooksMutation();
  const handleSubmit = async (data: CreateCredentialsQueryArg) => {
    const result = await createCredentials(data);
    if (result) {
      console.log('Action completed');
    }
  };
  const handleAddressBook = async () => {
    const result = await alignAddressBooks({ actionType: 'alignAddressBooks' });
    console.log(result);
  };

  return (
    <>
      <HeadingGroupContainerLayout>
        <HeadingGroup
          subtitlePrefix={'Page for testing purposes'}
          title={'Create API Credentials'}
        ></HeadingGroup>
      </HeadingGroupContainerLayout>
      <SectionContainerLayout>
        <CreateCredentialForm onSubmit={handleSubmit}></CreateCredentialForm>
        <Button onClick={handleAddressBook}>Align Address Books</Button>
      </SectionContainerLayout>
    </>
  );
};
